<template>
  <div class="audit-invoicing-dom">
    <!-- 头部 -->
    <div class="header">
      <van-nav-bar>
        <slot slot="title" name="title">
          <div class="header-title">填写发票信息</div>
        </slot>
      </van-nav-bar>
    </div>
    <!-- 内容 -->
    <div class="subject-content">
      <ModuleHeadText title="商品信息">
        <div class="add-goods" @click="handleAddGoods">
          <i class="huisuiyunfont iconfont">&#xe8fe;</i>
          <span>新增商品</span>
        </div>
      </ModuleHeadText>
      <transition-group name="run-good">
        <div class="content" v-for="(item, index) in invoiceInfo.details" :key="item.uuid">
          <span class="huisuiyunfont del" @click="handleDeleteGood(index)">{{'\ue61c'}}</span>
          <van-field v-model.trim="item.goodsName" label="开票项目" placeholder="请选择开票项目" :readonly="true" @click="setPopup(true, index)" required />
          <van-field
            v-model.trim="item.amountWithTax"
            label="开票金额"
            placeholder="请输入开票金额"
            type="number"
            required
            @input="handleFormatter($event, index)"
            @blur="handleFormatterBlur($event, index)"
          />
        </div>
      </transition-group>
      <ModuleHeadText title="发票抬头" />
      <div class="content">
        <van-field required name="radio" label="抬头类型">
          <template #input>
            <van-radio-group v-model="invoiceInfo.headUpType" direction="horizontal" @change="handleRadioChange">
              <van-radio icon-size="16px" name="1">企业单位</van-radio>
              <van-radio v-if="!isSpecialInvoice()" icon-size="16px" name="2">个人/非企业</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div class="company-name">
          <van-field v-model.trim="invoiceInfo.purchaserName" @input="handleChangeCompany($event, 'purchaserName')" label="发票抬头" placeholder="请输入发票抬头" required />
          <div class="rollup" v-if="companyNameList && companyNameList.length > 0">
            <div
              class="rollup-item"
              v-for="(item, index) in companyNameList"
              @click="handleCompany(item)"
              :key="index"
            >
              <div class="rollup-company">
                <div>{{ item.name }}</div>
                <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 企业所需 -->
        <div v-if="invoiceInfo.headUpType === '1'">
          <van-field :required="isSpecialInvoice()" v-model.trim="invoiceInfo.purchaserTaxNo" label="税号" placeholder="请输入税号" />
          <MoreData :defaultOpen="true">
            <van-field :required="isSpecialInvoice()" v-model.trim="invoiceInfo.purchaserAddress" label="地址" placeholder="请输入地址" />
            <van-field :required="isSpecialInvoice()" v-model.trim="invoiceInfo.purchaserTel" label="电话" placeholder="请输入电话" />
            <van-field :required="isSpecialInvoice()" v-model.trim="invoiceInfo.purchaserBankName" label="开户行" placeholder="请输入开户行" />
            <van-field :required="isSpecialInvoice()" v-model.trim="invoiceInfo.purchaserBankAccount" label="账号" placeholder="请输入账号">
              <template #button>
                <van-checkbox :value="!!(invoiceInfo.purchaserShowFlag)" icon-size="14px" shape="square" @click="changepurchaserShowFlag">是否展示</van-checkbox>
              </template>
            </van-field>
            <van-field v-model.trim="invoiceInfo.remark" label="备注" placeholder="请输入备注" />
          </MoreData>
        </div>
        <!-- 个人所需 -->
        <div v-else>
          <van-field v-model.trim="invoiceInfo.remark" label="备注" placeholder="请输入备注" />
        </div>
      </div>
      <ModuleHeadText v-if="getExtendField.length" title="其他内容" />
      <div class="customer-wrap" v-if="secretKey">
        <ExtendedFields :formData="invoiceInfo" :onChange="handleChangeInvoiceInfo" applyModule="5" :notAuth="true" :secretKey="secretKey" />
      </div>
      <div class="upload">
        <p class="upload-title">上传附件</p>
        <p class="annex-explain">每张单据最多上传9个附件且附件大小不超过100M</p>
        <!-- 102400 -->
        <InputField
          type="fileNoAuth"
          :fileList="invoiceInfo.paths"
          :maxCount="9"
          :multiple="true"
          :fileSize="102400"
          accept="image/*,.pdf,.zip,.doc,.docx,.ppt,.txt,.xls,.xlsx,.ofd"
          :noAuthParams="{companyId: parameter.companyId}"
          @oninputchange="($event) => handleChangeInvoiceInfo({e: $event, field:'paths'})"
          @finishUpload="finishUploadFile"
          @beforeDelete="deletePic"
        />
      </div>
      <ModuleHeadText title="接收信息" />
      <div class="content">
        <van-field v-model.trim="invoiceInfo.purchaserEmail" label="电子邮箱" placeholder="请输入电子邮箱" />
        <van-field v-model.trim="invoiceInfo.purchaserPhone" label="手机号码" placeholder="请输入手机号码" type="number" />
      </div>
    </div>
    <van-popup v-model="popupShow" round position="bottom" :style="{ height: '60%' }">
      <div class="goods-popup">
        <Loading v-if="goodsLoading" />
        <div class="title">
          开票项目
          <i @click="popupShow = false" class="huisuiyunfont iconfont">&#xe8fe;</i>
        </div>
        <div class="content">
          <van-radio-group v-model="invoiceInfo.goodId">
            <div class="good" v-for="(item) in selectGoods" :key="item.id" clickable @click="handleSelectGood(item)">
              <div class="good-radio">
                <van-radio icon-size="16px" :name="item.id" />
              </div>
              <div class="good-msg">
                <div>{{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}</div>
              </div>
            </div>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showTaxRateWarning"
      :close-on-click-overlay="false"
    >
      <div class="showBlankInvoice-wrp">
        <div class="showBlankInvoiceClose">
          <span class="pc-header-title-content">提示</span>
          <i @click="showTaxRateWarning = false" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="showBlankInvoice-content" style="flex-direction: column">
          <span class="taxplatemsg" v-for="(item, key) in taxRateWarningText" :key="key" style="margin-bottom: 10px">{{item}}</span>
        </div>
        <div class="submit-btn-wrp">
          <van-button
            loading-type="spinner"
            class="submit-btn"
            type="info"
            @click="showTaxRateWarning = false"
            >取消
          </van-button>
        </div>
      </div>
    </van-popup>
    <div class="btn" @click="handleSubmit">
      提交开票
    </div>
    <Loading v-if="loading" promptCopy="保存中,请稍后..." />
  </div>
</template>

<script>
import { getQuery, aesDoDecrypt, uuid, isEmail, testGoods, CheckBusinessMainInfo, autoMontageLookUp, onCheckTaxRate, deepCopy } from '@/utils/basicUtil'
import { NavBar, Icon, Field, Popup, RadioGroup, Radio, Cell, CellGroup, Notify, Checkbox } from 'vant'
import ModuleHeadText from '@/components/ModuleHeadText/index.vue'
import MoreData from '@/components/MoreData/index.vue'
import Loading from '@/components/Loading/index.vue'
import ExtendedFields from '@/components/ExtendedFields/index.vue'
import InputField from '@/components/InputField'
import { mapActions, mapState, mapMutations } from 'vuex'
import { isSpecialTicket } from '/src/utils/basicUtil'
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Notify.name]: Notify,
    [Checkbox.name]: Checkbox,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    ModuleHeadText,
    ExtendedFields,
    Loading,
    MoreData,
    InputField
  },
  data () {
    return {
      selectIndex: 0,
      popupShow: false,
      parameter: {},
      secretKey: '',
      invoiceInfo: {
        goodId: '',
        proxyFlag: 0,
        purchaserBankAccount: '',
        purchaserTel: '',
        headUpType: '1', // 1企业 2个人
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserAddress: '',
        purchaserShowFlag: '',
        purchaserBankName: '',
        settlementSource: '18',
        details: [{
          uuid: uuid()
        }],
        paths: [],
        remark: '',
        purchaserEmail: ''
      },
      purchaserPhone: '',
      showTaxRateWarning: false, // 税率警告提示框
      taxRateWarningText: [],
      taxRateResolve: () => {}
    }
  },
  mounted () {
    const { key } = getQuery()
    if (key) {
      this.secretKey = key
      this.parameter = aesDoDecrypt(key)
      console.log(this.parameter)
    }
    // eslint-disable-next-line new-cap
    this.checkTaxRate = new onCheckTaxRate()
  },
  computed: {
    ...mapState('auditInvoicing', ['companyNameList', 'selectGoods', 'goodsLoading', 'loading']),
    getExtendField () {
      return this.$store.state.user.extendField
    }
  },
  methods: {
    ...mapActions('auditInvoicing', ['getCompanyList', 'getSelectGoods', 'saveInvoiceInfo']),
    ...mapMutations('auditInvoicing', ['setCompanyNameList', 'setSelectGoods']),
    changepurchaserShowFlag () {
      this.invoiceInfo.purchaserShowFlag = this.invoiceInfo.purchaserShowFlag ? 0 : 1
    },
    isSpecialInvoice () {
      return isSpecialTicket(this.parameter.invoiceType)
    },
    handleDeleteGood (index) {
      if (this.invoiceInfo.details.length === 1) {
        Notify({ type: 'danger', message: '最后一条开票项目无法删除' })
        return
      }
      this.invoiceInfo.details.splice(index, 1)
    },
    handleAddGoods () {
      this.invoiceInfo.details.push({ uuid: uuid() })
    },
    handleChangeInvoiceInfo ({ e, field }) {
      if (!this.invoiceInfo[field]) {
        this.$set(this.invoiceInfo, field, e)
      } else {
        this.invoiceInfo[field] = e
      }
    },
    finishUploadFile (result) {
      if (result.code === '200') {
        let res = [
          ...this.invoiceInfo.paths
        ]
        if (res.length >= 9) {
          return
        }
        const target = {
          url: result.fileUrl,
          fileName: result.file.name
        }
        res.push(target)
        this.handleChangeInvoiceInfo({ e: res, field: 'paths' })
      } else {
        Notify({ type: 'danger', message: result.message })
      }
    },
    deletePic (file) {
      let res = this.invoiceInfo.paths.filter(item => item.url !== file.url)
      this.handleChangeInvoiceInfo({ e: res, field: 'paths' })
    },
    handleSelectGood (item) {
      const amountWithTax = this.invoiceInfo.details[this.selectIndex].amountWithTax
      const uuid = this.invoiceInfo.details[this.selectIndex].uuid
      this.invoiceInfo.details.splice(this.selectIndex, 1, {
        ...item,
        amountWithTax: amountWithTax || '',
        uuid: uuid || uuid(),
        unitPrice: item.price
      })
      this.setPopup(false)
    },
    handleCompany (item) {
      const { address, bankName, name, taxNo, tel, bankNo } = autoMontageLookUp(item, 7)
      this.invoiceInfo.purchaserName = name
      this.invoiceInfo.purchaserTaxNo = taxNo ? taxNo.toUpperCase() : taxNo
      this.invoiceInfo.purchaserAddress = `${address || ''}`
      this.invoiceInfo.purchaserBankName = `${bankName || ''}`
      this.invoiceInfo.purchaserTel = `${tel || ''}`
      this.invoiceInfo.purchaserBankAccount = `${bankNo || ''}`
      this.setCompanyNameList([])
    },
    handleRadioChange () {
      this.invoiceInfo.purchaserName = ''
      this.invoiceInfo.purchaserTaxNo = ''
      this.invoiceInfo.purchaserAddress = ''
      this.invoiceInfo.purchaserBankName = ''
      this.invoiceInfo.purchaserTel = ''
      this.invoiceInfo.purchaserBankAccount = ''
      this.invoiceInfo.remark = ''
      this.invoiceInfo.remark = ''
      this.invoiceInfo.purchaserShowFlag = ''
      this.setCompanyNameList([])
    },
    handleFormatter (e, index) {
      const value = e + ''
      if (value) {
        let integerPart = value.split('.')[0] || ''
        let decimalPart = value.split('.')[1] || ''
        // 如果小数部分长度大于2，需要截取
        if (decimalPart.length > 2) {
          this.invoiceInfo.details[index].amountWithTax = integerPart + '.' + (decimalPart.slice(0, 2))
        } else {
          this.invoiceInfo.details[index].amountWithTax = e
        }
      }
    },
    handleFormatterBlur (e, index) {
      if (e.target.value) {
        this.invoiceInfo.details[index].amountWithTax = Number(e.target.value).toFixed(2)
      }
    },
    onCheckImmediateLevyRefund () {
      // 添加即征即退商品类型校验，不能混开
      const arr = deepCopy(this.invoiceInfo.details)
      return new Promise(async (resolve) => {
        const result = await this.checkTaxRate.checkImmediateLevyRefund({ details: arr })
        if (result.length) {
          this.showTaxRateWarning = true
          this.taxRateWarningText = result
          this.taxRateResolve = resolve
        } else {
          resolve(true)
        }
      })
    },
    handleCheckCommodity () {
      const { details } = this.invoiceInfo
      // 不存在 | 长度不存在 | 找到了没有id的数据 进入
      if (!details || !details.length || details.find(i => !i.id)) {
        Notify({ type: 'danger', message: '请选择开票项目' })
        return false
      }
      // 找到了金额违法的数据 进入
      if (details.find(i => !i.amountWithTax || !i.amountWithTax.trim().length)) {
        Notify({ type: 'danger', message: '请补全开票项目金额' })
        return false
      }
      // 找到了金额 <= 0的数据 进入
      if (details.find(i => Number(i.amountWithTax) <= 0)) {
        Notify({ type: 'danger', message: '开票项目金额不能小于等于0' })
        return false
      }
      return true
    },
    async handleSubmit () {
      const {
        purchaserName,
        purchaserAddress,
        purchaserTel,
        remark,
        purchaserTaxNo,
        purchaserBankName,
        purchaserBankAccount,
        headUpType,
        purchaserPhone,
        purchaserEmail,
        details
      } = this.invoiceInfo
      const detailsFlag = this.handleCheckCommodity()
      if (!detailsFlag) return
      await this.onCheckImmediateLevyRefund()
      // headUpType === '2' 就是个人， 对全电来说就是自然人，审核开票拿不到发票类型所以统一判断
      try {
        const check = new CheckBusinessMainInfo({})
        check.purchaserName({ value: purchaserName, msg: '发票抬头' })
        if (headUpType !== '2') {
          check.purchaserTaxNo({ value: purchaserTaxNo, required: this.isSpecialInvoice() })
          check.purchaserAddress({ value: purchaserAddress, required: this.isSpecialInvoice() })
          check.purchaserTel({ value: purchaserTel, required: this.isSpecialInvoice() })
          check.purchaserBankName({ value: purchaserBankName, required: this.isSpecialInvoice() })
          check.purchaserBankAccount({ value: purchaserBankAccount, required: this.isSpecialInvoice() })
        }
        check.remark({ value: remark })
      } catch (error) {
        if (error.message) {
          Notify({ type: 'danger', message: error.message })
        }
        return
      }
      // 如果手机号存在
      if (purchaserPhone && purchaserPhone.trim()) {
        const re = /^1[3,4,5,6,7,8,9][0-9]{9}$/
        const result = re.test(purchaserPhone)
        if (!result) {
          return Notify({ type: 'danger', message: '手机号格式不正确' })
        }
      }
      // 如果手机号存在
      if (purchaserEmail && purchaserEmail.trim()) {
        if (!isEmail(purchaserEmail)) {
          return Notify({ type: 'danger', message: '邮箱格式不正确' })
        }
      }
      // 校验商品
      try {
        if (!testGoods({ list: details })) {
          return
        }
      } catch (error) {
      }
      // 扩展字段校验
      const extendRequiredList = (this.$store.state.user.extendField || []).filter(i => i.requiredFlag).map(i => i.interMapping)
      let extendFlag = false
      for (let index = 0; index < extendRequiredList.length; index++) {
        if (!this.invoiceInfo[extendRequiredList[index]]) {
          extendFlag = true
          break
        }
      }
      if (extendFlag) return Notify({ type: 'danger', message: '请填写必填的扩展字段' })
      const saveFlag = await this.saveInvoiceInfo({
        ...this.invoiceInfo,
        secretKey: this.secretKey,
        personLogo: headUpType === '2' ? 1 : 0
      })
      if (saveFlag) {
        this.$router.push('/audit-invoicing/submit-finish')
      }
    },
    handleChangeCompany (e, field) {
      if (field === 'purchaserName') {
        this.invoiceInfo.purchaserName = e
        if (e.length >= 1 && this.invoiceInfo.headUpType === '1') {
          // 请求接口
          this.getCompanyList(e)
        }
      }
    },
    setPopup (flag, index) {
      if (index || index === 0) {
        this.selectIndex = index
        this.invoiceInfo.goodId = this.invoiceInfo.details[index].id || ''
      }
      this.popupShow = flag
      // 请求接口查询已选商品
      this.getSelectGoods(this.secretKey)
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
